import { FormattedMessage, useIntl } from 'react-intl';
import { FormTextField } from '@components/common/FormTextField/FormTextField';
type FcaTextfieldProps = {
  name: string;
  locked?: boolean;
};

export function FcaTextfield({ name, locked = false }: FcaTextfieldProps) {
  const intl = useIntl();

  return (
    <>
      <FormattedMessage id={'auth.signup.financialConductAuthorityNumber'} />
      <FormTextField
        name={name}
        rules={
          locked
            ? undefined
            : {
                maxLength: {
                  value: 7,
                  message: intl.formatMessage({ id: 'common.error.validFCANumber' }),
                },
                minLength: {
                  value: 6,
                  message: intl.formatMessage({ id: 'common.error.validFCANumber' }),
                },
                pattern: {
                  value: /^\d{6,7}$/,
                  message: intl.formatMessage({ id: 'common.error.validFCANumber' }),
                },
                required: {
                  value: true,
                  message: intl.formatMessage({ id: 'common.error.requiredField' }),
                },
              }
        }
        disabled={locked}
        textFieldProps={{
          type: 'text',
          placeholder: intl.formatMessage({ id: 'placeholders.companyDetails.fca' }),
          inputProps: {
            sx: { padding: '6px !important' },
            className: 'text-sm font-normal!',
          },
        }}
      />
    </>
  );
}
